import type {
  ProductsQueryState,
  SyncProductsQueryFromURLPayload,
} from '../types/ProductsQueryState';
import { markActiveFacetOptions } from './markActiveFacetOptions';
import { markActiveSortOption } from './markActiveSortOption';

/**
 * Applies a URL-sync payload to the productsQuery state: marks the active facet
 * options and sort, and carries through page / searchTerm.
 *
 * `pageCategories` is intentionally NOT computed here — it is derived on read by
 * `selectPageCategories` (from the active facet selection for taxonomy pages, or
 * the SSR-init value for others), so there is a single source of truth.
 */
export const getProductsQueryStateFromSyncPayload = (
  productsQuery: ProductsQueryState,
  active: SyncProductsQueryFromURLPayload,
): ProductsQueryState => {
  const facets = markActiveFacetOptions(productsQuery.facets, active.activeFacetValuesByKey);

  return {
    ...productsQuery,
    facets,
    sortOptions: markActiveSortOption(productsQuery.sortOptions, active.activeSort),
    page: active.page,
    searchTerm: active.searchTerm,
  };
};
